import { useEffect } from 'react';

/**
 * 画面回転時に自動ズーム調整が発生することを防ぐコンポーネント (マウントするだけで有効)
 *
 * Android では画面を回転させたとき新しい表示がすべて画面内に収まるように自動的に
 * ズームアウトする挙動がある。
 * このアプリケーションの PC レイアウトでは、特定の幅未満を想定しないデザインになっており
 * 表示崩れを回避するため固定の幅を設定 (`body { min-width: 1366px; }`) している。
 * 画面を Portrait から Landscale に変更したとき、自動ズームアウトにより下部に
 * 画面外部分の何も存在しない領域が表示されてしまい不具合のように見えてしまうため、
 * 回転時に自動ズームアウトすることを防ぐ。
 */
function PreventZoomingOnRotation() {
  useViewportRewriterOnRotation();
  return null;
}

export default PreventZoomingOnRotation;

function useViewportRewriterOnRotation() {
  useEffect(() => {
    window.addEventListener('orientationchange', rotateWithNoScale);
    return () =>
      window.removeEventListener('orientationchange', rotateWithNoScale);
  }, []);
}

let timer: ReturnType<typeof setTimeout> | undefined;

/** 画面回転を検知するとしばらく viewport 設定を変更しズームアウトをさせないようにする */
function rotateWithNoScale() {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) return;

  const origin = viewport.getAttribute('content') ?? '';
  viewport.setAttribute(
    'content',
    'width=device-width,initial-scale=1.0,minimum-scale=1.0'
  );

  // 画面回転完了を検知する方法がないため、十分な時間経過後に元の viewport 設定に戻す。
  // 時間がぴったりでなくてもズームアウト操作が習慣的に 1, 2 回失敗するだけで問題なし。
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    timer = undefined;
    viewport.setAttribute('content', origin);
  }, 1000);
}
